import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useChatWidget from '../../hooks/useChatWidget';
import { CardCombinedType } from '../../types/chat.types';
import AdaptiveCard from '../adaptiveCard/AdaptiveCard';
import ChatUserInputSection from '../chatUserInputSection/ChatUserInputSection';
import socket from '../../socket';
import AdaptiveForm from '../adaptiveForm/AdaptiveForm';
import AdaptiveCardForm from '../adaptiveCardForm/adaptiveCardForm';
import { globalCards } from '../../utils/global.card';
import ChatBotTemplate from '../chatBotTemplate/ChatBotTemplate';
import PaymentCard from '../adaptiveCard/PaymentCard';
import { replaceDataPipe } from '../../utils/pipes';
import { AppDispatch, RootState } from '../../redux/store';
import {
  ADD_EVENT,
  DELETE_LAST_EVENT,
} from '../../redux/reducers/eventReducer';
import Chat from '../chat/Chat';
import Auth from '../auth/Auth';
import { zenworksServiceApi } from '../../service/zenworksService.api';
import PricingCalculator from '../adaptiveForm/PricingCalculator';

import './ChatWidget.css';
import ContactSales from '../card/ContactSales';
import FeedbackRating from '../FeedbackRating/FeedbackRating';
import getTimeStamp from '../../utils/getTimeStamp';
import BterAILoader from '../loader/BterAILoader';
import ToastMessage from '../toast/ToastMessage';
import { generateRandomId } from '../../utils/global.utils';
import ReferencenumberCard from '../card/ReferencenumberCard';
import CopilotIntro from '../copilotIntro';
import { RedirectToApp } from '../card/redirectToApp';
import { RedirectToDashboard } from '../card/redirectToDashboard';
import ContactDemo from '../card/ContactDemo';
import CalendlyCard from '../card/CalendlyCard';
import ChatLoader from '../loader/chatLoader';
import TransferHumanAgent from '../humanAgentTransfer/TransferHumanAgent';
import ConfirmationMsg from '../card/ConfirmationMsg';
import CalculateTaxAmount from '../card/CalculateTaxAmount';

let messageContainer: Element;
// let cardBox: HTMLDivElement;
const ChatWidget: React.FC = () => {
  const { messagesEndRef, scrollToBottom, sendChat, sendFile } =
    useChatWidget();
  const userName = useSelector((state: RootState) => state.user.user.FirstName);
  const form = useSelector((state: RootState) => state.form);
  const events = useSelector((state: RootState) => state.events);
  const authState = useSelector((state: RootState) => state.auth);
  const isLoading = useSelector((state: RootState) => state.loader.loading);
  const dispatch = useDispatch<AppDispatch>();

  const nullFunc = async (response: string, formFields?: any) => {
    if (response === 'customerSupportStep2') {
      await zenworksServiceApi.login({
        email: formFields[0],
        password: formFields[1],
        captcha: 'sdfdsfd',
      });
      handleCardClick(globalCards[response]);
    } else if (response === 'customizeAndCalculate') {
      const resp = await zenworksServiceApi.loginWithAppKey({
        login: formFields[0],
        password: formFields[1],
        appKey: formFields[2],
      });
      localStorage.setItem('appKey', resp.content.sessionId);
      handleCardClick({ type: 'pricing-calculator' });
    } else if (
      response !== '' &&
      Object.prototype.hasOwnProperty.call(globalCards, response)
    ) {
      handleCardClick(globalCards[response]);
    } else if (response === 'redirectToApp') {
      handleCardClick(globalCards[response]);
    } else {
      handleCardClick(globalCards['redirectToDashboard']);
    }
  };

  const handleSetResponse = async ({ type, data }: any) => {
    dispatch({ type, payload: data });
  };

  const handleCardClick = useCallback(
    async (card: CardCombinedType) => {
      pingServer();
      const timeStamp = getTimeStamp();
      if (card && card.type === 'display-data-card') {
        try {
          const result = await zenworksServiceApi.getSubmissions();
          const divId = generateRandomId();
          dispatch({
            type: ADD_EVENT,
            payload: {
              ...card,
              id: divId,
              divId,
              user: 'actionCard',
              time: timeStamp,
              senderType: 'chatBot',
              data: result,
            },
          });
        } catch (err) {
          console.error(err);
        }
      } else if (card.type === 'removeCard') {
        const lastChild = messageContainer.lastChild;
        if (lastChild) {
          messageContainer.removeChild(lastChild);
        }
      } else {
        const { deleteCard = false } = card;

        if (deleteCard) {
          dispatch({
            type: DELETE_LAST_EVENT,
            payload: {},
          });
        }
        const divId = generateRandomId();
        dispatch({
          type: ADD_EVENT,
          payload: {
            ...card,
            id: divId,
            divId,
            user: 'actionCard',
            time: timeStamp,
            senderType: 'chatBot',
          },
        });
      }
      scrollToBottom();
    },
    [dispatch, scrollToBottom],
  );

  const handelUserInput = (userInput: string) => {
    sendChat(userInput);
  };

  const pingServer = () => {
    zenworksServiceApi.ping();
  };

  useEffect(() => {
    scrollToBottom();
  }, [events, scrollToBottom]);

  useEffect(() => {
    function onConnect() {
      console.log('Connected!');
    }

    messageContainer = document.querySelector('#bterai-container') as Element;

    socket.on('connect', onConnect);


    return () => {
      socket.off('connect', onConnect);
    };
  }, []);

  return (
    <div className="bg-[#f5f5f5] flex flex-col h-full" aria-disabled={true}>
      <div
        id="bterai-container"
        ref={messagesEndRef}
        className="overflow-y-auto flex-grow p-3 bg-[#F9F9F9]"
      >
        {events && events.length === 0 && <CopilotIntro />}
        {[...events].map((card, index) => {
          if (card.type === 'chat' || card.type === 'file') {
            return (
              <div key={card.id} id={`chat-${card.id}`}>
                <Chat chat={card} sendFile={sendFile} />
              </div>
            );
          } else if (card.type === 'adaptive-card') {
            card.msg = replaceDataPipe(card.msg, '$User', userName);
            card.msg = replaceDataPipe(
              card.msg,
              '$loginUrl',
              'https://www.tax1099.com/Account/Login',
            );
            const formTemplateLink =
              form.formType === 'NEC'
                ? 'https://www.tax1099.com/Import/ImportNEC'
                : 'https://www.tax1099.com/Import/Import2';
            // For NEC: https://www.tax1099.com/Import/ImportNEC
            // For MISC: https://www.tax1099.com/Import/Import2
            card.msg = replaceDataPipe(
              card.msg,
              '$formTemplateLink',
              formTemplateLink,
            );
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <AdaptiveCard
                  card={card}
                  handleCardClick={handleCardClick}
                  handleSetResponse={handleSetResponse}
                  handelUserInput={handelUserInput}
                />
              </ChatBotTemplate>
            );
          } else if (card.type === 'adaptive-Button-from') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <AdaptiveCardForm card={card} handleFormSubmit={nullFunc} />
              </ChatBotTemplate>
            );
          } else if (card.type === 'pricingCalculatorCard') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <PricingCalculator />
              </ChatBotTemplate>
            );
          } else if (card.type === 'adaptive-from') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <AdaptiveForm forms={card} handleFormSubmit={nullFunc} />
              </ChatBotTemplate>
            );
          } else if (card.type === 'login-signup-form') {
            if (authState.auth) {
              // const newCard = globalCards[authState.type];
              nullFunc('existingTax1099User');
              // newCard.msg = replaceDataPipe(newCard.msg, '$User', userName);
              // return (
              //   <ChatBotTemplate key={index} timeStamp={card.time}>
              //     <AdaptiveCard
              //       card={newCard}
              //       handleCardClick={handleCardClick}
              //       handleSetResponse={handleSetResponse}
              //       handelUserInput={handelUserInput}
              //     />
              //   </ChatBotTemplate>
              // );
            }
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <Auth
                  cardScreen={authState.auth ? 'logged-in' : "SignUp"}
                  handleCardClick={nullFunc}
                  title={card.title ?? ""}
                />
              </ChatBotTemplate>
            );
          } else if (card.type === 'contactSale') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <ContactSales handleFormSubmit={nullFunc} data={card} />
              </ChatBotTemplate>
            );
          } 
          else if (card.type === 'contactDemo') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <ContactDemo handleFormSubmit={nullFunc} data={card} option={card.type}/>
              </ChatBotTemplate>
            );
          }
          else if (card.type === 'contactDiscountedPricing') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <ContactDemo handleFormSubmit={nullFunc} data={card} option={card.type}/>
              </ChatBotTemplate>
            );
          }
          else if (card.type === 'calendlyWidget') {
            return <CalendlyCard key={index} option={card.type}/>;
          }
          else if (card.type === 'calendlyWidgetIntroCall') {
            return <CalendlyCard key={index} option={card.type}/>;
          }
          if (card.type === 'loader') {
            return (
                <ChatLoader key={index}/>
            );
          } else if (card.type === 'paymentCard') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <PaymentCard card={card} handleFormSubmit={nullFunc} />
              </ChatBotTemplate>
            );
          } 
          else if (card.type === 'confirmationMsg') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <ConfirmationMsg />
              </ChatBotTemplate>
            );
          }
          else if (card.type === 'transfer_agent_card') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <TransferHumanAgent setShowPopup={() => {}} />
              </ChatBotTemplate>
            );
          }else if (card.type === 'display-data-card') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <p>Last 3 submissions status</p>

                {card.data.content.length === 0 && (
                  <div className="text-red-500">No submissions available</div>
                )}
                <table className="w-[100%] border-collapse border border-slate-400 ...">
                  <thead>
                    <tr>
                      <th className="py-1 px-2 text-left border border-slate-300">
                        Id
                      </th>
                      <th className="py-1 px-2 text-left border border-slate-300">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {card.data &&
                      card.data.content &&
                      card.data.content.length > 0 &&
                      card.data.content.map((item: any) => (
                        <tr key={item.Item1}>
                          <td className="py-1 px-2 text-left border border-slate-300">
                            {item.Item1}
                          </td>
                          <td className="py-1 px-2 text-left border border-slate-300">
                            {item.Item2}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </ChatBotTemplate>
            );
          } else if (card.type === 'feedback_card') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <FeedbackRating />
              </ChatBotTemplate>
            );
          } else if (card.type === 'messageCard') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                <p>{card.msg}</p>
              </ChatBotTemplate>
            );
          } else if (card.type === 'showReferenceNumberCard') {
            if (authState.auth) {
              return (
                <ChatBotTemplate key={index} timeStamp={card.time}>
                  <ReferencenumberCard />
                </ChatBotTemplate>
              )
            } else {
              return (
                <ChatBotTemplate key={index} timeStamp={card.time}>
                  <Auth
                    cardScreen={authState.auth ? 'logged-in' : card.title}
                    handleCardClick={nullFunc}
                  />
                </ChatBotTemplate>)
            }
          } else if (card.type === 'copilot_intro') {
            return (<ChatBotTemplate key={index} timeStamp={card.time}>
              <CopilotIntro />
            </ChatBotTemplate>)

          } else if (card.type === 'redirectToApp') {
            return (<ChatBotTemplate key={index} timeStamp={card.time}>
              <RedirectToApp />
            </ChatBotTemplate>)
          } else if (card.type === 'redirectToDashboard') {
            return (<ChatBotTemplate key={index} timeStamp={card.time}>
              <RedirectToDashboard />
            </ChatBotTemplate>)
          }
          else if (card.type === 'calculateTaxAmount') {
            return (
              <ChatBotTemplate key={index} timeStamp={card.time}>
                  <CalculateTaxAmount />
              </ChatBotTemplate>
            )
          }
          return null;
        })}
        {isLoading && <BterAILoader />}
      </div>

      <ToastMessage />
      <ChatUserInputSection handelUserInput={handelUserInput} handleSendAttachment={sendFile} />
      <p className="text-xs text-center pb-3 mb-3 bg-[#FFFFFF]">
        Accuracy is our goal, but errors may happen. Kindly double-check for
        important details.
      </p>
    </div>
  );
};

export default ChatWidget;
